// import axios from "axios";
// import { BASE_URL } from "src/constants";

// export const login = async (credentials) => {
//   return await axios.post(`${BASE_URL}/auth/login`, credentials);
// }

import axiosPrivateMl from "@services/axiosPrivateMl"

export const login = async (credentials) => {
  return await axiosPrivateMl.post(`/verify_login`, credentials);
}
